import { createClient } from 'next-sanity';

import { apiVersion, dataset, projectId, viewerToken, studioUrl } from './env';

export const client = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: process.env.SANITY_USE_CDN === 'true',
  token: viewerToken,
  stega: {
    studioUrl,
  },
});
